<template>
  <div class="ma-1">
    <div>
      <label for="">{{ this.label || "Hours" }}</label>
    </div>
    <div class="input-grid">
      <v-btn  @click="dec" ><v-icon>mdi-minus</v-icon></v-btn>
      <v-btn disabled  class="mx-1 flex-grow-0">{{ val }}</v-btn>
      <v-btn  @click="inc" ><v-icon>mdi-plus</v-icon></v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HoursInput',
  props: ['value', 'label', 'step'],
  data () {
    return {
      val: 0,
      st: 0.5
    }
  },
  methods: {
    inc () {
      this.val = this.val + this.st <= 23 ? this.val + this.st : this.val
      this.$emit('input', this.val)
    },
    dec () {
      this.val = this.val - this.st >= 0 ? this.val - this.st : 0
      this.$emit('input', this.val)
    }
  },
  mounted () {
    this.val = this.value || 0
    this.st = parseFloat(this.step) || 0.5
    console.log(this.value)
  }
}
</script>

<style scoped>
  .input-grid {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr auto;
  }
</style>
